import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Function to clean up expired daily todos
export const cleanupExpiredTodos = async () => {
  try {
    // Get all users
    const usersSnapshot = await getDocs(collection(db, 'users'));
    let totalDeleted = 0;
    
    for (const userDoc of usersSnapshot.docs) {
      const userId = userDoc.id;
      
      // Get expired todos for this user
      const todosQuery = query(
        collection(db, 'users', userId, 'dailyTodos'),
        where('expiresAt', '<=', new Date())
      );
      
      const expiredTodosSnapshot = await getDocs(todosQuery);
      
      // Delete expired todos
      const deletePromises = expiredTodosSnapshot.docs.map(async (todoDoc) => {
        await deleteDoc(doc(db, 'users', userId, 'dailyTodos', todoDoc.id));
        return todoDoc.id;
      });
      
      const deletedIds = await Promise.all(deletePromises);
      totalDeleted += deletedIds.length;
    }
    
    return { success: true, deletedCount: totalDeleted };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Function to get current IST time
const getCurrentISTTime = () => {
  const now = new Date();
  // IST is UTC+5:30
  const istTime = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
  return istTime;
};

// Function to check if cleanup is needed (can be called on app startup)
export const checkAndCleanupExpiredTodos = async () => {
  try {
    const istTime = getCurrentISTTime();
    
    // Check if it's past midnight IST (between 00:00 and 00:05)
    const hours = istTime.getUTCHours();
    const minutes = istTime.getUTCMinutes();
    
    // If it's between 12:00 AM and 12:05 AM IST, run cleanup
    if (hours === 0 && minutes < 5) {
      return await cleanupExpiredTodos();
    }
    
    return { success: true, cleanupNotNeeded: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Function to check if todos should be reset (for client-side use)
export const shouldResetTodos = () => {
  const istTime = getCurrentISTTime();
  const hours = istTime.getUTCHours();
  const minutes = istTime.getUTCMinutes();
  
  // Return true if it's between 12:00 AM and 12:10 AM IST
  return hours === 0 && minutes < 10;
};
